<template>
  <div class="footer">
    <div class="foot-v3-pc foot-v3-1-pc">
            <div class="foot-v3-mainbody">
                <div class="foot-v3-logo">
                    <a href="https://www.cgtn.com" class="foot-v3-logo-main"></a>
                </div>
                <div class="foot-v3-content">
                    <div class="foot-v3-list foot-v3-list-site">
                        <p class="foot-v3-list-title">SITEMAP</p>
                        <ul>
                            <li>
                                <a href="https://www.cgtn.com/china" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                    China        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/world" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                World        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/politics" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Politics        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/business" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Business        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/sci-tech" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Sci-Tech        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/culture" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Culture        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/sports" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Sports        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/opinions" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Opinions        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/travel" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Travel        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/nature" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Nature        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/picture" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Picture        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/video" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Video        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/live" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Live        </a>
                            </li>
                            <li>
                                <a href="https://radio.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Radio        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/specials" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Specials        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/transcript" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Transcript        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/europe" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                EUROPE        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/special/chinese-master" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Learn Chinese        </a>
                            </li>
                    </ul>
                    </div>
                    <div class="foot-v3-list foot-v3-list-explore">
                        <p class="foot-v3-list-title">EXPLORE MORE</p>
                        <ul>
                            <li>
                                <a href="https://www.cgtn.com/tv" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                English        </a>
                            </li>
                            <li>
                                <a href="https://espanol.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Español        </a>
                            </li>
                            <li>
                                <a href="https://francais.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Français        </a>
                            </li>
                            <li>
                                <a href="https://arabic.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                العربية        </a>
                            </li>
                            <li>
                                <a href="https://russian.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Русский        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/channel/documentary" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Documentary        </a>
                            </li>
                            <li>
                                <a href="http://www.cctvplus.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                CCTV+        </a>
                            </li>
                    </ul>
                    </div>
                    <div class="foot-v3-list foot-v3-list-down">
                        <p class="foot-v3-list-title">DOWNLOAD OUR APP</p>
                        <ul>
                            <li>
                                <a href="https://itunes.apple.com/us/app/cctvnews/id922456579" class="downicon apple" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.imib.cctv" class="downicon google" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://news.cgtn.com/download/CGTN.apk" class="downicon web" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/appletv-download" class="downicon apple-tv" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="foot-v3-list foot-v3-list-copy">
                        <p class="foot-v3-copy-common foot-v3-copy-right">
                            <span>Copyright © 2024 CGTN. </span>
                            <a href="http://beian.miit.gov.cn" target="_blank">京ICP备20000184号</a>
                        </p>
                        <div  class="foot-v3-copy-common foot-v3-copy-link">
                            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050052" target="_blank">
                                <img src="https://ui.cgtn.com/static/ng/resource/images/gwab.png" class="gwab-img-v3"/>
                                <span class="jgwab-num-v3">京公网安备 11010502050052号</span>
                            </a>
                        </div>
                        <p class="foot-v3-copy-common foot-v3-copy-hotline">Disinformation report hotline: 010-85061466</p>
                    </div>
                    <div class="foot-v3-list foot-v3-list-items">
                        <ul>
                            <li>
                                <a href="https://www.cgtn.com/terms-of-use" class="" target="_self" data-category="2023 Home" data-list="" data-action="TeamOfUs_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                    Terms of use
                                </a>
                                <span class="hr-r"></span>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/copyright" class="" target="_self" data-category="2023 Home" data-list="" data-action="Copyright_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                    Copyright
                                </a>
                                <span class="hr-r"></span>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/privacy" class="pdr0" target="_self" data-category="2023 Home" data-list="" data-action="PrivacyPolicy_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                    Privacy policy
                                </a>
                                <span class="hr-r"></span>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/about-us" class="" target="_self" data-category="2023 Home" data-list="" data-action="AboutUs_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                    About us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot-v3-m foot-v3-1-m">
            <div class="foot-v3-mainbody-m">
                <div class="foot-v3-logo-m">
                    <a href="https://www.cgtn.com" class="foot-v3-logo-main-m"></a>
                </div>
                <div class="foot-v3-list-site-m">
                    <p class="foot-v3-list-title-m">SITEMAP</p>
                    <ul>
                        <li>
                            <a href="https://www.cgtn.com/china" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                China        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/world" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            World        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/politics" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Politics        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/business" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Business        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/sci-tech" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Sci-Tech        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/culture" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Culture        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/sports" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Sports        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/opinions" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Opinions        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/travel" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Travel        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/nature" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Nature        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/picture" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Picture        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/video" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Video        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/live" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Live        </a>
                        </li>
                        <li>
                            <a href="https://radio.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Radio        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/specials" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Specials        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/transcript" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Transcript        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/europe" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            EUROPE        </a>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/special/chinese-master" class="" target="_self" data-category="2023 Home" data-list="" data-action="Sitemap_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            Learn Chinese        </a>
                        </li>
                    </ul>
                </div>
                <div class="foot-v3-center-m">
                    <div class="foot-v3-list-explore-m">
                        <p class="foot-v3-list-title-m">EXPLORE MORE</p>
                        <ul>
                            <li>
                                <a href="https://www.cgtn.com/tv" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                English        </a>
                            </li>
                            <li>
                                <a href="https://espanol.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Español        </a>
                            </li>
                            <li>
                                <a href="https://francais.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Français        </a>
                            </li>
                            <li>
                                <a href="https://arabic.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                العربية        </a>
                            </li>
                            <li>
                                <a href="https://russian.cgtn.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Русский        </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/channel/documentary" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Documentary        </a>
                            </li>
                            <li>
                                <a href="http://www.cctvplus.com" class="" target="_self" data-category="2023 Home" data-list="" data-action="ExploreMore_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                CCTV+        </a>
                            </li>
                        </ul>
                    </div>
                    <div class="foot-v3-list-down-m">
                        <p class="foot-v3-list-title-m">DOWNLOAD OUR APP</p>
                        <ul>
                            <li>
                                <a href="https://itunes.apple.com/us/app/cctvnews/id922456579" class="downicon apple" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.imib.cctv" class="downicon google" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://news.cgtn.com/download/CGTN.apk" class="downicon web" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                            <li>
                                <a href="https://www.cgtn.com/appletv-download" class="downicon apple-tv" target="_blank" data-category="2023 Home" data-list="" data-action="Download_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="foot-v3-list-copy-m">
                    <p class="foot-v3-copy-common-m foot-v3-copy-right-m">
                        <span>Copyright © 2024 CGTN. </span>
                        <a href="http://beian.miit.gov.cn" target="_blank">京ICP备20000184号</a>
                    </p>
                    <div  class="foot-v3-copy-common-m foot-v3-copy-link-m">
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050052" target="_blank">
                            <img src="https://ui.cgtn.com/static/ng/resource/images/gwab.png" class="gwab-img-v3"/>
                            <span class="jgwab-num-v3">京公网安备 11010502050052号</span>
                        </a>
                    </div>
                    <p class="foot-v3-copy-common-m foot-v3-copy-hotline-m">Disinformation report hotline: 010-85061466</p>
                </div>
                <div class="foot-v3-list-items-m">
                    <ul>
                        <li>
                            <a href="https://www.cgtn.com/terms-of-use" class="" target="_self" data-category="2023 Home" data-list="" data-action="TeamOfUs_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Terms of use
                            </a>
                            <span class="hr-r"></span>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/copyright" class="" target="_self" data-category="2023 Home" data-list="" data-action="Copyright_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Copyright
                            </a>
                            <span class="hr-r"></span>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/privacy" class="pdr0" target="_self" data-category="2023 Home" data-list="" data-action="PrivacyPolicy_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                Privacy policy
                            </a>
                            <span class="hr-r"></span>
                        </li>
                        <li>
                            <a href="https://www.cgtn.com/about-us" class="" target="_self" data-category="2023 Home" data-list="" data-action="AboutUs_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                About us
                            </a>
                        </li>
                    </ul>
                </div>    
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'footer'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  img{vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/components/Footer_v3.vue